module.exports = __webpack_public_path__ + "static/media/CSV.0e4bc5f4.svg";